export default __webpack_public_path__ + "static/media/audit_log_search_not_found.49000977.svg";